import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

import medhaviLogo from '../../assets/images/WhatsApp Image 2026-04-23 at 5.48.49 PM.jpeg';
import nsdcLogo from '../../assets/images/WhatsApp Image 2026-04-24 at 7.04.34 PM.jpeg';
import nsdcLogo2 from '../../assets/images/WhatsApp Image 2026-04-24 at 7.04.35 PM.jpeg';
import vpbLogo from '../../assets/images/VPB.jpeg';
import brandLogo from '../../assets/images/Untitled design (1).png';

const Footer = () => (
  <>
    {/* keep the marquee ticker if present */}
    <div className={styles.ticker}>
      <div className={styles.tickerMask}>
        <div className={styles.tickerTrack}>
          {[...Array(2)].map((_, ri) => (
            <span key={ri} className={styles.tickerInner}>
              {['Air Hostess', 'Airport Management', 'Customer Service', 'Aviation Training', '100% Placement Assistant', 'Industry Experts', 'Soft Skills', 'Grooming'].map(t => (
                <span key={t} className={styles.tickerItem}>✦ {t}</span>
              ))}
            </span>
          ))}
        </div>
      </div>
    </div>

    <footer className={styles.footer}>
      <div className={styles.gridOverlay} />

      <div className={`container ${styles.footerTop}`}>
        {/* Brand Section */}
        <div className={styles.brand}>
          <div className={styles.logoWrapper}>
            <img src={brandLogo} alt="Vin Fly Academy Logo" className={styles.logoImg} />
            <div className={styles.logoText}>
              <span className={styles.logoTextTop}>VIN FLY</span>
              <span className={styles.logoTextBottom}>AVIATION ACADEMY</span>
            </div>
          </div>
          <p className={styles.tagline}>Building India's Next Generation of Aviators</p>

          <div className={styles.socials}>
            <a href="https://www.instagram.com/vinflyaviation/" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="instagram" style={{ color: '#E1306C' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path d="M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path d="M17.5 6.5h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </a>
            <a href="https://www.facebook.com/profile.php?id=61583775628962" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="facebook" style={{ color: '#1877F2' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 2h-3a4 4 0 0 0-4 4v3H8v4h3v7h4v-7h3l1-4h-4V6a1 1 0 0 1 1-1h3z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </a>
            <a href="https://www.youtube.com/@VinFlyAviationAcademy" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="youtube" style={{ color: '#FF0000' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 7s-.2-1.4-.8-2c-.8-.9-1.7-.9-2.1-1C15.2 3 12 3 12 3s-3.2 0-6.9.1c-.4 0-1.3 0-2.1 1C2.2 5.6 2 7 2 7S2 8.8 2 10.6v2.8C2 16 3.2 17.4 3.2 17.4c.8 1 1.9 1 2.4 1.1C8.8 18.6 12 18.6 12 18.6s3.2 0 6.9-.1c.4 0 1.3 0 2.1-1 .6-.9.8-2 .8-2V10.6C22 8.8 22 7 22 7z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path d="M10 14l5-3-5-3v6z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </a>
            <a href="https://www.linkedin.com/in/vin-fly-aviation-0762b33b9" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} aria-label="linkedin" style={{ color: '#0A66C2' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2c-1 0-2 .7-2 2v7h-4v-14h4v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><rect x="2" y="9" width="4" height="11" rx="1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path d="M4 4v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </a>
          </div>
        </div>

        {/* NAVIGATE column */}
        <div className={styles.col}>
          <p className={styles.colHead}>NAVIGATE</p>
          <Link to="/" className={styles.colLink}>Home</Link>
          <Link to="/about" className={styles.colLink}>About</Link>
          <Link to="/courses" className={styles.colLink}>Courses</Link>
          <Link to="/admissions" className={styles.colLink}>Admissions</Link>
          <Link to="/gallery" className={styles.colLink}>Gallery</Link>
          <a href="https://forms.zohopublic.in/vinflyaviationacademy1/form/JobApplicationFormVINFlyAviationAcademy/formperma/6wKPw8x2uJzFqVAxY0nnKBFmOceLlNO-sU17b_n4y58" target="_blank" rel="noopener noreferrer" className={styles.colLink}>Career</a>
          <Link to="/contact" className={styles.colLink}>Contact</Link>
        </div>

        {/* PROGRAMS & PORTALS column */}
        <div className={styles.col}>
          <p className={styles.colHead}>PROGRAMS</p>
          <Link to="/courses" className={styles.colLink}>Air Hostess Training</Link>
          <Link to="/courses" className={styles.colLink}>Airport Management</Link>
          <Link to="/courses" className={styles.colLink}>Customer Service Executive</Link>

          <p className={styles.colHead} style={{ marginTop: '32px' }}>PORTALS</p>
          <a href="https://cms.schoolonapp.com/?school=2vfaap&sessionlabel=2026-27&session=26_27" target="_blank" rel="noopener noreferrer" className={styles.colLink}>Official Login</a>
          <a href="https://app.schoolonapp.com/?school=2vfaap&sessionlabel=2026-27&session=26_27" target="_blank" rel="noopener noreferrer" className={styles.colLink}>Student Login</a>
        </div>

        {/* REACH US column */}
        <div className={styles.col}>
          <p className={styles.colHead}>REACH US</p>
          <div className={styles.contactList}>
            <a href="https://maps.google.com/maps?q=Gat+No+452/1/1,+Gandharva+Nagari,+Nashik+Road,+Moshi,+Haveli,+PUNE-412105" target="_blank" rel="noopener noreferrer" className={styles.contactItemLink}>
              <div className={styles.contactIconWrapper}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
              </div>
              <span className={styles.contactText}>Gat No 452/1/1, Gandharva Nagari, Nashik Road, Moshi, Haveli, PUNE-412105</span>
            </a>

            <div className={styles.contactItem}>
              <div className={styles.contactIconWrapper}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
              </div>
              <span className={styles.contactText}>
                <a href="tel:+919960555941" className={styles.inlinePhone}>+91 9960 555 941</a>
                <span className={styles.phoneSep}>•</span>
                <a href="tel:+919960555942" className={styles.inlinePhone}>+91 9960 555 942</a>
              </span>
            </div>

            <a href="mailto:contact@vinaviation.com" className={styles.contactItemLink}>
              <div className={styles.contactIconWrapper}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
              </div>
              <span className={styles.contactText}>contact@vinaviation.com</span>
            </a>

            <div className={styles.contactItem}>
              <div className={styles.contactIconWrapper}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
              </div>
              <p className={styles.contactText}>Mon-Sat, 9:00 AM - 6:00 PM IST</p>
            </div>
          </div>
        </div>
      </div>



      <div className={styles.divider} />

      <div className={`container ${styles.footerBottom}`}>
        <div className={styles.partnerBarsContainer}>
          <div className={styles.partnerGroup}>
            <span className={styles.partnerHeading}>Under program of</span>
            <div className={styles.partnerLogos}>
              <img src={vpbLogo} alt="VPB Education Foundation" />
            </div>
          </div>

          <div className={styles.partnerDivider}></div>

          <div className={styles.partnerGroup}>
            <span className={styles.partnerHeading}>Affiliated partner with</span>
            <div className={styles.partnerLogos}>
              <img src={medhaviLogo} alt="Partner 1" />
              <img src={nsdcLogo} alt="Partner 2" />
              <img src={nsdcLogo2} alt="Partner 3" />
            </div>
          </div>
        </div>

        <div className={styles.legal}>
          <Link to="/privacy-policy" className={styles.legalLink}>Privacy Policy</Link>
          <Link to="/terms-of-use" className={styles.legalLink}>Terms of Use</Link>
        </div>
      </div>

      <div className={styles.divider} />

      <div className={styles.copyrightWrapper}>
        <div className={`container ${styles.copyrightInner}`}>
          <p className={styles.copy}>© 2026 VIN Fly Aviation Academy. All rights reserved.</p>
          <p className={styles.copy}>Website Developed by <a href="https://inflyx.co.in" target="_blank" rel="noopener noreferrer" style={{ color: '#03989E' }}>INFLYX Creative Studio</a></p>
        </div>
      </div>
    </footer>
  </>
);

export default Footer;
